// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Text_wrap__Yt_KI","input":"Text_input__SFyqS","label":"Text_label__LOC73"};